(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artscroll-sale-experience"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSaleNavigation = () => {
      document.querySelectorAll('.as-sale').forEach((sale) => {
        if (sale.dataset.saleNavigationReady === 'true') return;

        const mapElement = document.querySelector(`[data-sale-product-map="${sale.id.replace('artscroll-sale-', '')}"]`);
        const grid = sale.querySelector('[data-sale-product-grid]');
        if (!mapElement || !grid) return;

        let productMap;
        try {
          productMap = JSON.parse(mapElement.textContent);
        } catch (error) {
          return;
        }

        const dataByHandle = Object.fromEntries(productMap.map((item) => [item.handle, item]));
        const cards = Array.from(grid.querySelectorAll('[data-handle]'));
        const covers = Array.from(sale.querySelectorAll('[data-sale-cover]'));
        const typeLinks = Array.from(sale.querySelectorAll('[data-sale-types]'));
        const priceLinks = Array.from(sale.querySelectorAll('[data-sale-price]'));
        const status = sale.querySelector('[data-sale-results-status]');
        const search = sale.querySelector('[data-sale-search]');
        const sort = sale.querySelector('[data-sale-sort]');
        const empty = sale.querySelector('[data-sale-empty]');
        const reset = sale.querySelector('[data-sale-reset]');
        const url = new URL(window.location.href);

        const state = {
          types: url.searchParams.get('sale_types') || '*',
          priceKey: url.searchParams.get('sale_price') || 'all',
          minPrice: null,
          maxPrice: null,
          inStock: false,
          query: (url.searchParams.get('sale_search') || '').toLowerCase(),
          sort: url.searchParams.get('sale_sort') || 'featured'
        };

        const setPriceState = (link) => {
          state.priceKey = link?.dataset.salePrice || 'all';
          state.minPrice = link?.dataset.salePriceMin ? Number(link.dataset.salePriceMin) : null;
          state.maxPrice = link?.dataset.salePriceMax ? Number(link.dataset.salePriceMax) : null;
          state.inStock = link?.dataset.saleAvailable === 'true';
        };

        const initialPriceLink = priceLinks.find((link) => link.dataset.salePrice === state.priceKey);
        setPriceState(initialPriceLink || priceLinks.find((link) => link.dataset.salePrice === 'all'));
        if (search) search.value = state.query;
        if (sort) sort.value = state.sort;

        const matchesState = (item) => {
          if (!item) return false;
          const acceptedTypes = state.types === '*' ? [] : state.types.split('|').filter(Boolean);
          const matchesType = state.types === '*' || acceptedTypes.includes(item.type);
          const matchesMinimum = state.minPrice === null || Number(item.price) >= state.minPrice;
          const matchesMaximum = state.maxPrice === null || Number(item.price) <= state.maxPrice;
          const matchesStock = !state.inStock || item.available;
          const matchesSearch = !state.query || item.title.includes(state.query);
          return matchesType && matchesMinimum && matchesMaximum && matchesStock && matchesSearch;
        };

        const sortCards = () => {
          const sorted = [...cards].sort((leftCard, rightCard) => {
            const left = dataByHandle[leftCard.dataset.handle];
            const right = dataByHandle[rightCard.dataset.handle];
            if (!left || !right) return 0;
            if (state.sort === 'price-ascending') return Number(left.price) - Number(right.price);
            if (state.sort === 'price-descending') return Number(right.price) - Number(left.price);
            if (state.sort === 'title-ascending') return left.title.localeCompare(right.title);
            if (state.sort === 'title-descending') return right.title.localeCompare(left.title);
            return Number(left.position) - Number(right.position);
          });
          sorted.forEach((card) => grid.appendChild(card));
        };

        const render = (updateUrl, scrollToGrid) => {
          const visibleProducts = productMap.filter(matchesState);
          const visibleHandles = new Set(visibleProducts.map((item) => item.handle));

          cards.forEach((card) => {
            card.classList.toggle('is-sale-filtered-out', !visibleHandles.has(card.dataset.handle));
          });

          covers.forEach((cover) => {
            cover.classList.toggle('is-sale-filtered-out', !visibleHandles.has(cover.dataset.handle));
          });

          typeLinks.forEach((link) => {
            const isActive = link.dataset.saleTypes === state.types;
            link.classList.toggle('is-active', isActive);
            if (isActive) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });

          priceLinks.forEach((link) => {
            link.classList.toggle('is-active', link.dataset.salePrice === state.priceKey);
          });

          sortCards();

          if (status) {
            const isUnfiltered = state.types === '*' && state.priceKey === 'all' && !state.query;
            status.textContent = `${visibleProducts.length} ${isUnfiltered ? sale.dataset.allLabel : sale.dataset.filteredLabel}`;
          }

          if (empty) empty.hidden = visibleProducts.length !== 0;

          if (updateUrl) {
            const nextUrl = new URL(window.location.href);
            if (state.types === '*') nextUrl.searchParams.delete('sale_types');
            else nextUrl.searchParams.set('sale_types', state.types);
            if (state.priceKey === 'all') nextUrl.searchParams.delete('sale_price');
            else nextUrl.searchParams.set('sale_price', state.priceKey);
            if (state.query) nextUrl.searchParams.set('sale_search', state.query);
            else nextUrl.searchParams.delete('sale_search');
            if (state.sort === 'featured') nextUrl.searchParams.delete('sale_sort');
            else nextUrl.searchParams.set('sale_sort', state.sort);
            nextUrl.hash = 'sale-products';
            window.history.replaceState({}, '', nextUrl);
          }

          if (scrollToGrid) {
            sale.querySelector('#sale-products')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        };

        typeLinks.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            state.types = link.dataset.saleTypes || '*';
            render(true, true);
          });
        });

        priceLinks.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            setPriceState(link);
            render(true, true);
          });
        });

        search?.addEventListener('input', () => {
          state.query = search.value.trim().toLowerCase();
          render(true, false);
        });

        sort?.addEventListener('change', () => {
          state.sort = sort.value;
          render(true, false);
        });

        reset?.addEventListener('click', () => {
          state.types = '*';
          state.query = '';
          state.sort = 'featured';
          const allPriceLink = priceLinks.find((link) => link.dataset.salePrice === 'all');
          setPriceState(allPriceLink);
          if (search) search.value = '';
          if (sort) sort.value = 'featured';
          render(true, true);
        });

        render(false, false);
        sale.dataset.saleNavigationReady = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeSaleNavigation, { once: true });
    } else {
      initializeSaleNavigation();
    }

    document.addEventListener('shopify:section:load', initializeSaleNavigation);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jsq-atelier-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(scope) {
    scope.querySelectorAll('.jsq-home-rail').forEach(wrapper => {
      if (wrapper.dataset.railReady) return;
      const rail = wrapper.querySelector('[data-jsq-home-rail]');
      const controls = wrapper.querySelector('.jsq-home-rail__controls');
      if (!rail || !controls) return;
      wrapper.dataset.railReady = 'true';
      const previous = controls.querySelector('[data-jsq-rail-prev]');
      const next = controls.querySelector('[data-jsq-rail-next]');
      const status = controls.querySelector('[data-jsq-rail-status]');
      function update() {
        const max = rail.scrollWidth - rail.clientWidth;
        controls.hidden = rail.clientWidth < 1 || max < 3;
        previous.disabled = rail.scrollLeft < 3;
        next.disabled = rail.scrollLeft > max - 3;
        if (status && !controls.hidden) {
          const bounds = rail.getBoundingClientRect();
          const cards = [...rail.children];
          const visible = cards.map((card, index) => {
            const rect = card.getBoundingClientRect();
            return Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) >= rect.width / 2 ? index + 1 : 0;
          }).filter(Boolean);
          if (visible.length) {
            const range = `${visible[0]}, ${visible[visible.length - 1]} / ${cards.length}`;
            if (status.textContent !== range) status.textContent = range;
          }
        }
      }
      function move(direction) {
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        rail.scrollBy({left: direction * (rail.clientWidth + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(rail);
      update();
    });
    scope.querySelectorAll('[data-jsqa-products]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      function select(tab, focus) {
        tabs.forEach(button => {
          const active = button === tab;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
        if (focus) tab.focus({ preventScroll: true });
        tab.scrollIntoView({block: "nearest", inline: "nearest", behavior: "instant"});

      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab, false));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(tabs[next], true); }
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jsq-daf-shop"]) return;
  try {
    
(function(){
  const root=document.getElementById('daf-shop');if(!root)return;
  const cards=Array.from(root.querySelectorAll('.daf-card'));
  const filter=root.querySelector('#daf-filters');
  const result=root.querySelector('#daf-results');
  const empty=root.querySelector('#daf-empty');
  const preview=new URLSearchParams(location.search).get('preview_theme_id');
  function safeLink(value){try{const url=new URL(value,location.origin);if(url.origin!==location.origin)return value;if(preview&&/^\d+$/.test(preview))url.searchParams.set('preview_theme_id',preview);return url.pathname+url.search+url.hash;}catch(error){return value;}}
  root.querySelectorAll('a[href]').forEach(a=>{if(a.getAttribute('href').startsWith('/'))a.href=safeLink(a.getAttribute('href'));});
  function updateCard(card){
    const select=card.querySelector('.daf-volume');if(!select)return;
    const option=select.selectedOptions[0];if(!option)return;
    const link=card.querySelector('.daf-buy');
    link.href=safeLink(option.value);
    const available=option.dataset.available==='true';
    link.replaceChildren(document.createTextNode(available?root.dataset.shopLabel:root.dataset.unavailableLabel));
    const arrow=document.createElement('span');arrow.textContent='↗';arrow.setAttribute('aria-hidden','true');link.appendChild(arrow);
    const price=card.querySelector('.daf-price');if(price)price.textContent=option.dataset.price;
    const status=card.querySelector('.daf-availability');if(status)status.textContent=available?root.dataset.available:root.dataset.soldOut;
    const img=card.querySelector('.daf-cover-image');if(img&&option.dataset.image){img.removeAttribute('srcset');img.src=option.dataset.image;if(card.dataset.example!=='true')img.alt=card.querySelector('h2').textContent+', '+option.dataset.label;}
    link.setAttribute('aria-label',link.textContent+', '+card.querySelector('h2').textContent+', '+option.dataset.label);
  }
  cards.forEach(card=>{const select=card.querySelector('.daf-volume');if(select){select.addEventListener('change',()=>updateCard(card));updateCard(card);}});
  function applyFilter(){const selected=filter?filter.querySelector('input[name="daf-language"]:checked').value:'all';const format=filter?filter.querySelector('#daf-format').value:'all';let count=0;cards.forEach(card=>{const show=(selected==='all'||card.dataset.language===selected)&&(format==='all'||card.dataset.format===format);card.hidden=!show;if(show)count++;});result.textContent=root.dataset.results.replace('__COUNT__',String(count));result.hidden=false;empty.hidden=count!==0;}
  if(filter){filter.hidden=false;filter.addEventListener('change',applyFilter);filter.addEventListener('submit',event=>event.preventDefault());}applyFilter();
  document.addEventListener('keydown',event=>{if(event.key==='Escape')root.querySelectorAll('details[open]').forEach(details=>details.open=false);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jsq-gift-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initializeGiftFinders() {
      document.querySelectorAll('[data-jgf]').forEach(root => {
        if (root.dataset.jgfReady) return;
        const occasion = root.querySelector('[data-jgf-occasion]');
        const budget = root.querySelector('[data-jgf-budget]');
        const available = root.querySelector('[data-jgf-available]');
        const cta = root.querySelector('[data-jgf-cta]');
        const summary = root.querySelector('[data-jgf-summary]');
        const choices = root.querySelector('[data-jgf-choices]');
        if (!occasion || !budget || !available || !cta || !choices) return;
        function update() {
          const url = new URL(occasion.value || root.dataset.fallbackUrl, window.location.origin);
          if (url.origin !== window.location.origin) return;
          const range = new URLSearchParams(budget.value);
          ['gte', 'lte'].forEach(key => {
            if (range.has(key)) url.searchParams.set('filter.v.price.' + key, range.get(key));
          });
          if (available.checked) url.searchParams.set('filter.v.availability', '1');
          cta.setAttribute('href', url.pathname + url.search);
          if (summary) summary.textContent = occasion.selectedOptions[0].textContent.trim() + ' · ' + budget.selectedOptions[0].textContent.trim();
        }
        [occasion, budget, available].forEach(input => input.addEventListener('change', update));
        update();
        choices.hidden = false;
        root.dataset.jgfReady = 'true';
      });
    }
    initializeGiftFinders();
    document.addEventListener('shopify:section:load', initializeGiftFinders);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jsq-home-discovery"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(scope) {
    scope.querySelectorAll('.jsq-home-rail').forEach(wrapper => {
      if (wrapper.dataset.railReady) return;
      const rail = wrapper.querySelector('[data-jsq-home-rail]');
      const controls = wrapper.querySelector('.jsq-home-rail__controls');
      if (!rail || !controls) return;
      wrapper.dataset.railReady = 'true';
      const previous = controls.querySelector('[data-jsq-rail-prev]');
      const next = controls.querySelector('[data-jsq-rail-next]');
      const status = controls.querySelector('[data-jsq-rail-status]');
      function update() {
        const max = rail.scrollWidth - rail.clientWidth;
        controls.hidden = rail.clientWidth < 1 || max < 3;
        previous.disabled = rail.scrollLeft < 3;
        next.disabled = rail.scrollLeft > max - 3;
        if (status && !controls.hidden) {
          const bounds = rail.getBoundingClientRect();
          const cards = [...rail.children];
          const visible = cards.map((card, index) => {
            const rect = card.getBoundingClientRect();
            return Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) >= rect.width / 2 ? index + 1 : 0;
          }).filter(Boolean);
          if (visible.length) {
            const range = `${visible[0]}, ${visible[visible.length - 1]} / ${cards.length}`;
            if (status.textContent !== range) status.textContent = range;
          }
        }
      }
      function move(direction) {
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        rail.scrollBy({left: direction * (rail.clientWidth + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(rail);
      update();
    });
    scope.querySelectorAll('[data-jsq-discovery]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      function select(tab, focus) {
        tabs.forEach(button => {
          const active = button === tab;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
        if (focus) tab.focus({ preventScroll: true });

      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab, false));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(tabs[next], true); }
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jsq-new-releases"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jsq-release-list')) {
  customElements.define('jsq-release-list', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.events = new AbortController();
      const signal = this.events.signal;
      const shelves = Array.from(this.querySelectorAll('[data-release-shelf]'));
      let cards = Array.from(this.querySelectorAll('[data-release-kind]'));
      const empty = this.querySelector('[data-release-empty]');
      const expireCards = () => {
        const today = Math.floor(Date.now() / 86400000) * 86400000;
        cards.forEach(card => {
          const raw = card.dataset.releaseDate;
          const start = Date.parse((raw.length === 7 ? raw + '-01' : raw) + 'T00:00:00Z');
          if (!Number.isFinite(start) || start < today - 90 * 86400000) card.remove();
        });
        cards = cards.filter(card => card.isConnected);
        shelves.forEach(shelf => {
          const shelfCards = cards.filter(card => card.dataset.releaseKind === shelf.dataset.releaseShelf);
          shelfCards.forEach((card, index) => { card.hidden = index >= (shelf.dataset.releaseShelf === 'books' ? 12 : shelfCards.length); });
          shelf.hidden = shelfCards.length === 0;
          const jump = this.closest('section')?.querySelector(`[data-release-jump="${shelf.dataset.releaseShelf}"]`);
          if (jump) jump.hidden = shelf.hidden;
        });
        empty.hidden = cards.some(card => !card.hidden);
      };
      expireCards();
      this.expiryTimer = setInterval(expireCards, 60000);
      this.refreshExpiry = expireCards;
      document.addEventListener('visibilitychange', expireCards, {signal});
      window.addEventListener('pageshow', expireCards, {signal});
      const alignAnchor = () => {
        if (location.hash === '#jsq-new-releases') this.closest('section')?.scrollIntoView({block: 'start', behavior: 'instant'});
      };
      window.addEventListener('load', () => requestAnimationFrame(alignAnchor), {once: true, signal});
      window.addEventListener('hashchange', () => requestAnimationFrame(alignAnchor), {signal});
      requestAnimationFrame(alignAnchor);
      this.shelfObservers = [];
      shelves.forEach(shelf => {
      const track = shelf.querySelector('.jsq-releases__shelf-track');
      const controls = shelf.querySelector('[data-shelf-controls]');
      const previous = shelf.querySelector('[data-shelf-previous]');
      const next = shelf.querySelector('[data-shelf-next]');
      if (track && controls && previous && next) {
        const updateControls = () => {
          const max = track.scrollWidth - track.clientWidth;
          controls.hidden = max <= 2;
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= max - 2;
        };
        const move = direction => track.scrollBy({left: direction * track.clientWidth * 0.9, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        previous.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        track.addEventListener('scroll', updateControls, {passive: true, signal});
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        }, {signal});
        window.addEventListener('resize', updateControls, {signal});
        const observer = new ResizeObserver(updateControls);
        observer.observe(track);
        this.shelfObservers.push(observer);
        requestAnimationFrame(updateControls);
      }
      });
    }
    disconnectedCallback() {
      clearInterval(this.expiryTimer);
      this.events?.abort();
      this.shelfObservers?.forEach(observer => observer.disconnect());
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jsq-release-browser"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jsq-release-browser')) {
  customElements.define('jsq-release-browser', class extends HTMLElement {
    connectedCallback() {
      if (this.initialize) return;
      this.initialize = () => {
        const chunks = Array.from(document.querySelectorAll('.jsq-browser-chunk'));
        const host = this.closest('.jsq-browser-chunk');
        const grid = host.querySelector('.jsq-releases__grid');
        let cards = chunks.flatMap(chunk => Array.from(chunk.querySelectorAll('[data-release-kind]')));
        const search = this.querySelector('[data-browser-search]');
        const category = this.querySelector('[data-browser-category]');
        const publisher = this.querySelector('[data-browser-publisher]');
        const edition = this.querySelector('[data-browser-edition]');
        const summary = this.querySelector('[data-browser-summary]');
        const pages = host.querySelector('.jsq-browser__pages');
        const previous = host.querySelector('[data-browser-previous]');
        const next = host.querySelector('[data-browser-next]');
        const pageLabel = host.querySelector('[data-browser-page]');
        let page = 1;
        const pageSize = 24;
        const sort = (a,b) => b.dataset.releaseDate.localeCompare(a.dataset.releaseDate) || a.dataset.releaseTitle.localeCompare(b.dataset.releaseTitle) || a.querySelector('a').href.localeCompare(b.querySelector('a').href);
        cards.sort(sort).forEach(card => grid.append(card));
        chunks.filter(chunk => chunk !== host).forEach(chunk => { chunk.hidden = true; });
        const populate = (select,key) => [...new Set(cards.map(card=>card.dataset[key]))].sort().forEach(value => { const option=document.createElement('option');option.value=value;option.textContent=key==='releaseEdition'&&value==='Vendor arrival'?'Gift':value;select.append(option); });
        populate(publisher,'releasePublisher');populate(edition,'releaseEdition');
        const render = () => {
          const term = search.value.trim().toLocaleLowerCase();
          const matches = cards.filter(card => (category.value==='all'||card.dataset.releaseKind===category.value) && (publisher.value==='all'||card.dataset.releasePublisher===publisher.value) && (edition.value==='all'||card.dataset.releaseEdition===edition.value) && (!term||card.dataset.releaseTitle.toLocaleLowerCase().includes(term)));
          const totalPages=Math.max(1,Math.ceil(matches.length/pageSize));page=Math.min(page,totalPages);
          const visible=new Set(matches.slice((page-1)*pageSize,page*pageSize));cards.forEach(card=>{card.hidden=!visible.has(card);});
          summary.textContent=matches.length ? `${matches.length} matching listings · showing ${(page-1)*pageSize+1}, ${Math.min(page*pageSize,matches.length)}` : 'No matching releases. Try another title or filter.';
          pageLabel.textContent=`Page ${page} of ${totalPages}`;previous.disabled=page===1;next.disabled=page===totalPages;pages.hidden=matches.length===0;
        };
        const expire = () => {
          const oldest=Math.floor(Date.now()/86400000)*86400000-90*86400000;
          cards.forEach(card=>{const raw=card.dataset.releaseDate;const day=Date.parse((raw.length===7?raw+'-01':raw)+'T00:00:00Z');if(!Number.isFinite(day)||day<oldest)card.remove();});
          cards=cards.filter(card=>card.isConnected);render();
        };
        [search,category,publisher,edition].forEach(control=>control.addEventListener(control===search?'input':'change',()=>{page=1;render();}));
        const move = delta => {page+=delta;render();host.scrollIntoView({block:'start',behavior:'auto'});};
        previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
        expire();this.timer=setInterval(expire,60000);this.expire=expire;document.addEventListener('visibilitychange',expire);window.addEventListener('pageshow',expire);
      };
      if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',this.initialize,{once:true});else this.initialize();
    }
    disconnectedCallback(){clearInterval(this.timer);document.removeEventListener('DOMContentLoaded',this.initialize);document.removeEventListener('visibilitychange',this.expire);window.removeEventListener('pageshow',this.expire);}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jsq-retail-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jqr-book-rail')) {
  customElements.define('jqr-book-rail', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const initialize = () => {
        if (signal.aborted || !this.isConnected) return;
        const track = this.querySelector('[data-book-track]');
        const prev = this.querySelector('[data-book-prev]');
        const next = this.querySelector('[data-book-next]');
        if (!track || !prev || !next) return;
        const sync = () => {
          this.toggleAttribute('overflowing', track.scrollWidth > track.clientWidth + 2);
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        const step = (direction) => {if (!track.firstElementChild) return; track.scrollBy({left: direction * (track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});};
        prev.addEventListener('click', () => step(-1), {signal:this.abort.signal});
        next.addEventListener('click', () => step(1), {signal:this.abort.signal});
        track.addEventListener('scroll', sync, {passive:true, signal:this.abort.signal});
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault(); step(event.key === 'ArrowRight' ? 1 : -1);}
          if (event.key === 'Home' || event.key === 'End') {event.preventDefault(); track.scrollTo({left:event.key === 'Home' ? 0 : track.scrollWidth});}
        }, {signal:this.abort.signal});
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(sync);
          this.observer.observe(track);
        } else {
          window.addEventListener('resize', sync, {signal});
        }
        sync();
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once:true, signal});
      } else {
        queueMicrotask(initialize);
      }
    }
    disconnectedCallback() {this.abort?.abort(); this.observer?.disconnect();}
  });
}
if (!customElements.get('jqr-discovery')) {
  customElements.define('jqr-discovery', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const initialize = () => {
        if (signal.aborted || !this.isConnected) return;
        const tabs = [...this.querySelectorAll('[data-discovery-tab]')];
        const panels = [...this.querySelectorAll('[data-discovery-panel]')];
        if (!tabs.length || tabs.length !== panels.length) return;
        const navigation = this.querySelector('[data-discovery-tabs]');
        const picker = this.querySelector('[data-discovery-picker]');
        navigation.setAttribute('role', 'tablist');
        const select = (tab) => {
          if (picker) picker.value = tab.dataset.discoveryTab;
          tabs.forEach(item => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
          });
          panels.forEach(panel => { panel.hidden = panel.dataset.discoveryPanel !== tab.dataset.discoveryTab; });
          if (picker) return;
          const tabRect = tab.getBoundingClientRect();
          const navRect = navigation.getBoundingClientRect();
          if (tabRect.left < navRect.left) navigation.scrollLeft += tabRect.left - navRect.left - 12;
          else if (tabRect.right > navRect.right) navigation.scrollLeft += tabRect.right - navRect.right + 12;
        };
        tabs.forEach((tab, index) => {
          const panel = panels.find(item => item.dataset.discoveryPanel === tab.dataset.discoveryTab);
          if (!panel) return;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          tab.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault(); select(tab);
          }, {signal:this.abort.signal});
          tab.addEventListener('keydown', event => {
            if (event.key === ' ') {event.preventDefault(); select(tab); return;}
            let destination = index;
            if (event.key === 'ArrowRight') destination = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') destination = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') destination = 0;
            else if (event.key === 'End') destination = tabs.length - 1;
            else return;
            event.preventDefault(); select(tabs[destination]); tabs[destination].focus();
          }, {signal:this.abort.signal});
        });
        if (picker) {
          this.querySelector('[data-discovery-picker-wrap]').hidden = false;
          navigation.hidden = true;
          panels.forEach((panel, index) => {
            panel.setAttribute('role', 'region');
            panel.removeAttribute('aria-labelledby');
            panel.setAttribute('aria-label', tabs[index].textContent.trim());
          });
          picker.addEventListener('change', () => {
            const selected = tabs.find(tab => tab.dataset.discoveryTab === picker.value);
            if (selected) select(selected);
          }, {signal});
        }
        select(tabs[0]);
        this.setAttribute('ready', '');
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once:true, signal});
      } else {
        queueMicrotask(initialize);
      }
    }
    disconnectedCallback() {this.abort?.abort();}
  });
}
if (!customElements.get('jqr-directory')) {
  customElements.define('jqr-directory', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const initialize = () => {
        if (signal.aborted || !this.isConnected) return;
        const disclosure = this.querySelector('details');
        const trigger = disclosure?.querySelector('summary');
        const close = this.querySelector('[data-directory-close]');
        if (!disclosure || !trigger || !close) return;
        this.setAttribute('ready', '');
        const dismiss = () => {disclosure.open = false; trigger.focus();};
        close.addEventListener('click', dismiss, {signal:this.abort.signal});
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && disclosure.open) {event.preventDefault(); dismiss();}
        }, {signal:this.abort.signal});
        document.addEventListener('click', event => {
          if (disclosure.open && !this.contains(event.target)) disclosure.open = false;
        }, {signal:this.abort.signal});
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once:true, signal});
      } else {
        queueMicrotask(initialize);
      }
    }
    disconnectedCallback() {this.abort?.abort();}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solo4-authority-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSolo4 = (section) => {
      if (section.dataset.solo4Bound === 'true') return;
      section.dataset.solo4Bound = 'true';
    const image = section.querySelector('.js4-gallery__image');
    const form = section.querySelector('.js4-form');
    const variantInput = section.querySelector('[data-variant-input]');
    const price = section.querySelector('[data-variant-price]');
    const title = section.querySelector('[data-variant-title]');
    const addButton = section.querySelector('[data-add-button]');
    const addText = section.querySelector('[data-add-text]');
    const upsellCheckbox = section.querySelector('[data-upsell-checkbox]');
    const upsellCard = section.querySelector('[data-upsell-card]');
    const bundleTotal = section.querySelector('[data-bundle-total]');
    const cartError = section.querySelector('[data-cart-error]');
    const variantButtons = Array.from(section.querySelectorAll('[data-variant-button]'));
    let submitting = false;
    let pendingControls = [];
    let originalAddText = '';

    const restoreSubmission = () => {
      submitting = false;
      pendingControls.forEach(({ control, disabled }) => { control.disabled = disabled; });
      pendingControls = [];
      form?.removeAttribute('aria-busy');
      if (addText) addText.textContent = originalAddText;
    };

    const selectedVariantPrice = () => {
      const selected = section.querySelector('[data-variant-button].is-active');
      return Number(selected?.dataset.variantPriceCents || 0);
    };

    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    }).format(cents / 100);

    const updateBundleState = () => {
      if (submitting) return;
      if (!upsellCheckbox || !upsellCard || !addButton || !addText) return;
      const selected = upsellCheckbox.checked;
      const upsellPrice = Number(upsellCheckbox.dataset.upsellPriceCents || 0);
      const total = selectedVariantPrice() + upsellPrice;
      upsellCard.classList.toggle('is-selected', selected);
      addText.textContent = selected
        ? `${addButton.dataset.bundleLabel}, ${formatMoney(total)}`
        : addButton.dataset.addLabel;
      if (bundleTotal) {
        bundleTotal.textContent = selected
          ? `${bundleTotal.dataset.bundleLabel} ${formatMoney(total)}`
          : bundleTotal.dataset.optionalLabel;
      }
    };

    upsellCheckbox?.addEventListener('change', updateBundleState);

    variantButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (submitting) return;
        section.querySelectorAll('[data-variant-button]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        if (variantInput) variantInput.value = button.dataset.variantId || '';
        if (price) price.textContent = button.dataset.variantMoney || '';
        if (title) title.textContent = button.dataset.variantTitle || '';

        if (image && button.dataset.variantImage) {
          image.style.opacity = '0';
          window.setTimeout(() => {
            image.src = button.dataset.variantImage;
            image.removeAttribute('srcset');
            image.alt = button.dataset.variantAlt || '';
            image.style.opacity = '1';
          }, 120);
        }

        if (addButton) addButton.disabled = false;
        updateBundleState();

        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', button.dataset.variantId || '');
        window.history.replaceState({}, '', nextUrl);
      });
    });

    const initialUrl = new URL(window.location.href);
    if (initialUrl.searchParams.has('variant') && initialUrl.searchParams.get('variant') !== variantInput?.value) {
      initialUrl.searchParams.set('variant', variantInput?.value || '');
      window.history.replaceState({}, '', initialUrl);
    }

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (submitting || !variantInput?.value || !addButton || !addText || addButton.disabled) return;

      const selectedVariantId = variantInput.value;
      const caseAdded = Boolean(upsellCheckbox?.checked && upsellCheckbox.dataset.upsellVariantId);
      const items = [{ id: Number(selectedVariantId), quantity: 1 }];
      if (caseAdded) {
        items.push({ id: Number(upsellCheckbox.dataset.upsellVariantId), quantity: 1 });
      }

      originalAddText = addText.textContent;
      submitting = true;
      pendingControls = [addButton, ...variantButtons, upsellCheckbox].filter(Boolean)
        .map((control) => ({ control, disabled: control.disabled }));
      pendingControls.forEach(({ control }) => { control.disabled = true; });
      form.setAttribute('aria-busy', 'true');
      if (cartError) {
        cartError.textContent = '';
        cartError.hidden = true;
      }
      addText.textContent = addButton.dataset.addingLabel;
      const root = window.Shopify?.routes?.root || '/';

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) throw new Error('Cart add failed');
      } catch (error) {
        restoreSubmission();
        if (cartError) {
          cartError.textContent = addButton.dataset.errorLabel;
          cartError.hidden = false;
        } else {
          addText.textContent = addButton.dataset.errorLabel;
        }
        return;
      }

      try {
        window.dataLayer?.push({
          event: 'solo4_add_to_cart',
          solo4_variant_id: selectedVariantId,
          rugged_case_added: caseAdded,
        });
      } catch {}
      window.location.assign(`${root}cart`);
    });

    window.addEventListener('pageshow', (event) => {
      if (event.persisted && submitting) restoreSubmission();
    });

    updateBundleState();
    };

    document.querySelectorAll('[data-solo4-section]').forEach(initSolo4);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches?.('[data-solo4-section]')
        ? event.target
        : event.target.querySelector?.('[data-solo4-section]');
      if (section) initSolo4(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yarmulka-wizard"] && !Shopify.designMode) return;
  try {
    
(() => {
  function start(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const copy = JSON.parse(root.querySelector('[data-yf-copy]').textContent);
    const form = root.querySelector('[data-yf-form]');
    const status = root.querySelector('[data-yf-status]');
    const coverage = root.querySelector('[data-yf-coverage]');
    const results = root.querySelector('[data-yf-results]');
    const more = root.querySelector('[data-yf-more]');
    const load = root.querySelector('[data-yf-load]');
    const fallback = root.querySelector('[data-yf-fallback]');
    const fallbackHref = fallback.href;
    const browse = root.querySelector('[data-yf-browse]');
    const control = name => form.elements.namedItem(name);
    const state = { products: [], pages: 0, page: 0, total: 0, path: '', request: 0, shown: 24, loading: false };
    const maxPages = 8;
    const format = (text, values) => text.replace(/\{(\w+)\}/g, (_, key) => values[key] ?? '');
    const sizeOption = name => /(^|\s)(size|sizes|sizing|fit)(\s|$)/i.test(name);
    const colorOption = name => /^(color|colour)$/i.test(name.trim());
    const usableColor = (product, value) => {
      const normalize = text => String(text || '').trim().toLowerCase().replace(/\s+/g, ' ');
      const color = normalize(value);
      return color && color !== normalize(product.title) && !/^ikippah\b.*\byarmulk(?:e|a|ah|es|as)\b/i.test(color);
    };
    const valuesFor = (product, variant, test) => product.options.flatMap((name, index) => test(name) && variant.options[index] && (test !== colorOption || usableColor(product, variant.options[index])) ? [String(variant.options[index])] : []);
    const variantMatches = (product, variant, omit) => (!control('available').checked || variant.available) && (omit === 'size' || !control('size').value || valuesFor(product, variant, sizeOption).includes(control('size').value)) && (omit === 'color' || !control('color').value || valuesFor(product, variant, colorOption).includes(control('color').value));
    const productMatches = product => !control('brand').value || product.vendor === control('brand').value;
    function options(name, values, label) {
      const select = control(name);
      const previous = select.value;
      if (previous && !values.includes(previous)) values.push(previous);
      select.replaceChildren(new Option(label, ''));
      [...new Set(values)].sort((a, b) => a.localeCompare(b, undefined, { numeric: true })).forEach(value => select.add(new Option(value, value)));
      if (values.includes(previous)) select.value = previous;
      select.disabled = state.loading || !values.length;
    }
    function updateOptions() {
      options('brand', state.products.map(p => p.vendor).filter(Boolean), copy.any_brand);
      const eligible = state.products.filter(productMatches);
      options('size', eligible.flatMap(p => p.variants.filter(v => variantMatches(p, v, 'size')).flatMap(v => valuesFor(p, v, sizeOption))), copy.any_size);
      options('color', eligible.flatMap(p => p.variants.filter(v => variantMatches(p, v, 'color')).flatMap(v => valuesFor(p, v, colorOption))), copy.any_color);
    }
    function render() {
      const matches = state.products.filter(productMatches).flatMap(p => { const v = p.variants.find(v => variantMatches(p, v)); return v ? [{ p, v }] : []; });
      const partial = state.page < state.pages || state.products.some(p => p.variant_count > p.variants.length);
      results.replaceChildren();
      matches.slice(0, state.shown).forEach(({ p, v }) => {
        const article = document.createElement('article');
        const link = document.createElement('a');
        const url = new URL(p.url, location.origin);
        url.searchParams.set('variant', v.id);
        link.href = url.pathname + url.search;
        if (v.image || p.image) { const image = document.createElement('img'); image.src = v.image || p.image; image.alt = p.title; image.width = 400; image.height = 400; image.loading = 'lazy'; link.append(image); }
        const title = document.createElement('h3'); title.textContent = p.title; link.append(title);
        const maker = document.createElement('p'); maker.textContent = p.vendor;
        const price = document.createElement('p'); price.textContent = v.price;
        const optionsLine = document.createElement('p'); optionsLine.className = 'jsq-yf__options';
        optionsLine.textContent = p.options.flatMap((name, index) => /^style$/i.test(name.trim()) || sizeOption(name) || (colorOption(name) && usableColor(p, v.options[index])) ? [`${name}: ${v.options[index]}`] : []).join(' · ') || copy.unknown;
        const action = document.createElement('span'); action.className = 'jsq-yf__action'; action.textContent = v.available ? copy.view : copy.sold_out;
        link.append(maker, price, optionsLine, action); article.append(link); results.append(article);
      });
      const loaded = format(copy.loaded, { loaded: state.products.length, total: state.total });
      status.textContent = loaded + ' ' + (matches.length ? format(copy.results, { count: matches.length }) : copy.empty) + (partial ? ' ' + copy.partial : '');
      const eligible = state.products.filter(productMatches);
      const withSize = eligible.filter(p => p.variants.some(v => valuesFor(p, v, sizeOption).length)).length;
      const withColor = eligible.filter(p => p.variants.some(v => valuesFor(p, v, colorOption).length)).length;
      coverage.hidden = !eligible.length;
      coverage.textContent = format(copy.coverage, { size: withSize, color: withColor, total: eligible.length });
      more.hidden = matches.length <= state.shown;
      load.hidden = state.page >= state.pages || state.page >= maxPages;
    }
    async function fetchPages() {
      const request = ++state.request;
      state.loading = true;
      load.hidden = true;
      ['brand', 'size', 'color'].forEach(name => control(name).disabled = true);
      status.textContent = copy.loading;
      const end = Math.min(state.page + 3, maxPages);
      try {
        while (state.page < end && (!state.pages || state.page < state.pages)) {
          const pageNumber = state.page + 1;
          const url = new URL(state.path, location.origin);
          url.searchParams.set('view', 'yarmulka-data');
          url.searchParams.set('page', pageNumber);
          const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
          if (!response.ok) throw new Error('data-response');
          const documentData = new DOMParser().parseFromString(await response.text(), 'text/html');
          const payload = documentData.querySelector('[data-yf-page]');
          if (!payload) throw new Error('data-payload');
          const data = JSON.parse(payload.textContent);
          if (request !== state.request) return;
          if (data.page !== pageNumber || !Array.isArray(data.products)) throw new Error('data-page');
          state.products.push(...data.products.filter(p => !state.products.some(existing => existing.id === p.id)));
          state.page = data.page; state.pages = data.pages; state.total = data.total;
          status.textContent = copy.loading + ' ' + format(copy.loaded, { loaded: state.products.length, total: state.total });
        }
        state.loading = false;
        updateOptions(); render();
      } catch (error) {
        if (request !== state.request) return;
        state.loading = false;
        updateOptions();
        if (state.products.length) render();
        status.textContent = copy.failed + (state.products.length ? ' ' + format(copy.loaded, { loaded: state.products.length, total: state.total }) : '');
        load.hidden = state.page >= maxPages;
      }
    }
    form.addEventListener('submit', event => event.preventDefault());
    form.addEventListener('change', event => {
      state.shown = 24;
      if (event.target.name === 'material') {
        state.request++; state.products = []; state.page = 0; state.pages = 0; state.total = 0; state.loading = false; state.path = control('material').value;
        results.replaceChildren(); more.hidden = true; load.hidden = true; coverage.hidden = true;
        ['brand', 'size', 'color'].forEach(name => { control(name).value = ''; control(name).disabled = true; });
        if (!state.path) { fallback.href = fallbackHref; browse.open = true; status.textContent = copy.choose; return; }
        fallback.href = state.path;
        browse.open = false;
        fetchPages();
      } else if (state.path && !state.loading && state.page) { updateOptions(); render(); }
    });
    form.addEventListener('reset', () => { setTimeout(() => { state.request++; state.products = []; state.page = 0; state.pages = 0; state.total = 0; state.path = ''; state.loading = false; results.replaceChildren(); more.hidden = true; load.hidden = true; coverage.hidden = true; fallback.href = fallbackHref; browse.open = true; status.textContent = copy.choose; ['brand', 'size', 'color'].forEach(name => { control(name).replaceChildren(new Option(copy[`any_${name}`], '')); control(name).disabled = true; }); }, 0); });
    more.addEventListener('click', () => { state.shown += 24; render(); });
    load.addEventListener('click', () => { if (!state.loading && state.path) fetchPages(); });
    form.hidden = false;
    status.textContent = copy.choose;
  }
  document.querySelectorAll('[data-yarmulka-finder]').forEach(start);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-yarmulka-finder]').forEach(start));
})();

  } catch(e) { console.error(e); }
})();
})();
